var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import getId from "@irati/utils/id";
import { injectIntl } from "@irati/utils/lang";
import Search from "./UserSearch";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 20px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 20px;\n"])));
var Title = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 10px;\n"], ["\n  margin-right: 10px;\n"])));
var NameHeader = /** @class */ (function (_super) {
    __extends(NameHeader, _super);
    function NameHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NameHeader.prototype.render = function () {
        var idNamespace = getId("NameHeader", this.props);
        var _a = this.props, title = _a.title, onChange = _a.onChange, jobRole = _a.jobRole, formatMessage = _a.formatMessage;
        return (React.createElement(Wrapper, { id: idNamespace },
            React.createElement(Title, null, title || formatMessage({ id: "admin.reportingV2.wallet.columns.name.title" })),
            React.createElement(Search, { onFilter: onChange, role: jobRole })));
    };
    return NameHeader;
}(PureComponent));
export default injectIntl(NameHeader);
var templateObject_1, templateObject_2;
